module.exports = "pegasus_template/assets/blocks/tile-layout-05.png";